import * as React from 'react';

import type {
    EditionFragment as DripEdition,
    SmsDripEditionFragment as SmsDripEdition,
} from 'nutshell-graphql-types';

import {EmailDripEditionPreview} from './email-drip-edition-preview';
import {SmsDripEditionPreview} from './sms-drip-edition-preview';

type Props = {
    selectedEdition: DripEdition | SmsDripEdition;
    streetAddress?: string | null | undefined;
    canAccessSetup: boolean;
};

export function EditionPreview(props: Props) {
    return (
        <>
            {props.selectedEdition.__typename === 'Edition' ? (
                <EmailDripEditionPreview
                    selectedEdition={props.selectedEdition}
                    streetAddress={props.streetAddress}
                    canAccessSetup={props.canAccessSetup}
                />
            ) : (
                <SmsDripEditionPreview selectedEdition={props.selectedEdition} />
            )}
        </>
    );
}
